module.exports = __webpack_public_path__ + "media/images/Branding/HW_White-5164910728969e7db23d1a01442075d2.png";